<template>
    <b-row>
        <b-col cols="12">
            <div class="d-none chart-container" :style="{height:'80px',width: '160px'}">
                <canvas id="worker-chart-pie"></canvas>
            </div>

            <div class="d-none chart-container" :style="{height:'80px',width: '160px'}">
                <canvas id="subs-composition-chart-pie"></canvas>
            </div>

            <div class="d-none chart-container" :style="{height:'80px',width: '160px'}">
                <canvas id="importance-composition-chart-pie"></canvas>
            </div>

            <div class="d-none chart-container" :style="{height:'650px',width: '650px'}">
                <canvas id="category1-chart-area"></canvas>
            </div>

            <div class="d-none chart-container" :style="{height:'650px',width: '650px'}">
                <canvas id="category2-contrary-chart-area" height="650" width="650"></canvas>
            </div>

            <!-- <div class="d-none chart-container" :style="{height:'80px',width: '160px'}">
                <canvas id="category1-chart-bar"></canvas>
            </div> -->

            <div class="d-none chart-container" :style="{height:'650px',width: '300px'}">
                <canvas id="category1-chart-bar"></canvas>
            </div>

            <div class="d-none chart-container" :style="{height:'80px',width: '160px'}">
                <canvas id="category1-chart-pie"></canvas>
            </div>

            <div class="d-none chart-container" :style="{height:'80px',width: '160px'}">
                <canvas id="par-chart-bar"></canvas>
            </div>

            <div class="d-none chart-container" :style="{height:'80px',width: '160px'}">
                <canvas id="par-category1-chart-area"></canvas>
            </div>

            <div id="full-report-hyundai">
                <div id="pdf-preview" style="width: 100%; height: 600px; border: 1px solid black;"></div>
            </div>
        </b-col>
    </b-row>
</template>

<script>
import ReportMixinHYUNDAI from '@shared/mixin/report/report.hyundai.mixin';

export default {
    name: 'ReportViewerHYUNDAI',
    mixins: [
        ReportMixinHYUNDAI
    ],
    components: {},
    props: {},
    data() {
        return {};
    },
    computed: {},
    watch: {
        report_lang: {
            async handler(_aft, _bef) {
                this.$emit('self-report-update', true);
                this.report_local_lang = _aft;
                if (_bef != _aft) {
                    this.$nextTick(async () => {
                        await this.previewPDF();
                    });
                }

                this.$emit('self-report-update', false);
            }
        },
        '$i18n.locale': {
            async handler(_aft, _bef) {
                this.$emit('self-report-update', true);
                this.report_local_lang = _aft;
                if (_bef != _aft) {
                    this.$nextTick(async () => {
                        await this.previewPDF();
                    });
                }

                this.$emit('self-report-update', false);
            }
        },
        async needReport (_is_needed_report) {
            if (_is_needed_report) {
                await this.emitSendReportBlob();
            }
        },
        reportMode () {
            this.$emit('self-report-update', true);

            this.$nextTick(async () => {
                await this.previewPDF();
            });

            this.$emit('self-report-update', false);
        },
        assessmentType () {
            this.$emit('self-report-update', true);

            this.$nextTick(async () => {
                await this.previewPDF();
            });

            this.$emit('self-report-update', false);
        },
        is_reassessment () {
            this.$emit('self-report-update', true);

            this.$nextTick(async () => {
                await this.previewPDF();
            });

            this.$emit('self-report-update', false);
        },
        set_actual_duration () {
            this.$emit('self-report-update', true);

            this.$nextTick(async () => {
                await this.previewPDF();
            });

            this.$emit('self-report-update', false);
        },
        is_report_self_update (_self_update_state) {
            this.$emit('self-report-update', _self_update_state);
        }
    },
    async mounted () {
        this.is_report_self_update = true;
        this.initializeReport();
        await this.addFontVFS();
        this.$nextTick(async () => {
            await this.previewPDF();
        });
        this.is_report_self_update = false;
    },
    destroyed() {
        this.initializeReport();

        this.is_report_self_update = false;
        this.pageContentWidth = 0;
        this.pageContentHeight = 0;
        this.factors = null;

        this.jsPDF_instance = null;
    },
    methods: {
        async savePDF () {
            const doc = await this.generatePDF();
            doc.save(`${this.local_pdf_filename}.pdf`);
        },
        async previewPDF () {
            this.is_report_self_update = true;
            const pdfBlobData = await this.generatePDF(true);

            if (this.needReport) {
                this.$emit('sendReportBlob', {
                    data: pdfBlobData,
                    filename: this.local_pdf_filename
                });

                return pdfBlobData;
            } else {
                const blobURL = URL.createObjectURL(pdfBlobData);
                const iframe = document.createElement('iframe');
                iframe.src = blobURL;
                iframe.style.width = '100%';
                iframe.style.height = '100%';

                const pdfPreview = document.getElementById('pdf-preview');
                pdfPreview.innerHTML = '';
                pdfPreview.appendChild(iframe);
            }
            this.is_report_self_update = false;
        },
        async emitSendReportBlob () {
            this.is_report_self_update = true;
            const pdfBlobData = await this.generatePDF(true);
            
            this.$emit('sendReportBlob', {
                data: pdfBlobData,
                filename: this.local_pdf_filename
            });
            this.is_report_self_update = false;
        }
    }
};
</script>
